module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("You have "), _c('span', [_vm._v("(" + _vm._s(Object.keys(_vm.categories).length) + ")")]), _vm._v(" Shop Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
    return _c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setCategory(category)
        }
      }
    }, [_c('div', {
      staticClass: "card-row"
    }, [_c('p', {
      staticStyle: {
        "color": "#353434"
      }
    }, [(category.business_parent_category != 'None') ? _c('span', [_c('span', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v(_vm._s(category.business_parent_category))]), (category.business_category && (category.business_category != '')) ? _c('span', [_c('br'), _vm._v(_vm._s(category.business_category))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(category.business_category_name))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(category.business_category_total_products) + " product(s) ")])]), _vm._v(" "), _vm._m(1, true), _c('br')]), _vm._v(" "), _c('hr')])])])
  }), _vm._v(" "), ((_vm.categories && Object.keys(_vm.categories).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("You have not added any Category yet")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/newcategory"
    }
  }, [_vm._v("Add New Category")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\r\n              O P E N "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "inherit",
      "outline": "0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b950527"}!./src/pages/Account/Sellpoint/Categories/template.html
// module id = 536
// module chunks = 0